import styled from 'styled-components';
import { BOX_SHADOW } from '@styles/global-style';
import { BodyTextSmall } from 'lib/design-system';
import {
  borderRadius,
  breakpointMediumStart,
  neutral0,
  spacing2,
  spacing6,
  spacing3,
  spacing8,
  neutral200,
  spacing0,
  spacing4,
  ButtonBase,
  fontWeightRegular,
  neutral600,
  neutral400,
  accent5,
} from 'lib/mortar';
import { SelectionButtonContainer } from 'components/Funnelling/styles';

export const RAQBannerWrapper = styled.div<StyledDiv>`
  border-top: 1px solid ${neutral200};
  border-radius: 0 0 ${borderRadius(4)} ${borderRadius(4)};
  padding: ${spacing4};
  width: calc(100% + ${spacing8});
  background: ${neutral0};

  @media screen and (min-width: ${breakpointMediumStart}) {
    width: 100%;
    border-radius: ${borderRadius(4)};
    border: none;
    padding: ${spacing6};

    ${SelectionButtonContainer} {
      grid-template-columns: 1fr 1fr;
    }
  }

  ${BodyTextSmall} {
    margin: ${spacing3} ${spacing0};
  }
`;

export const NewRAQBannerWrapper = styled(
  RAQBannerWrapper.withComponent('button'),
)`
  background: ${accent5};
  border-radius: ${borderRadius(4)};
  cursor: pointer;
  box-shadow: ${BOX_SHADOW};
  box-sizing: border-box;
  margin-top: ${spacing6};
  padding: ${spacing4} ${spacing4} ${spacing2};
  width: 100%;
  max-width: 772px;
`;

export const FauxButton = styled(ButtonBase)`
  padding: ${spacing4};
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  color: ${neutral600};
  text-align: left;
  cursor: pointer;
  border: 1px solid ${neutral400};
  border-radius: ${borderRadius(2)};
  font-weight: ${fontWeightRegular};
  min-height: 106px;
`;

export const DesktopView = styled.div<StyledDiv>`
  display: none;

  @media screen and (min-width: ${breakpointMediumStart}) {
    display: block;
  }
`;

export const MobileView = styled.div<StyledDiv>`
  display: block;

  @media screen and (min-width: ${breakpointMediumStart}) {
    display: none;
  }
`;
